import { Component, Inject } from '@angular/core'; 
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-Tool-Tip',
  templateUrl: './tool-tip.component.html',
  styleUrls: ['./tool-tip.component.scss']
})
export class TooltipComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { policyType: string }) {}

  ngOnInit() {
    console.log('Policy type in tooltip:', this.data.policyType);
  }
}